import styled from '@emotion/styled'

import { breakpoints, palette, spacing, typography } from 'main/ui'

export const Container = styled.div<{ backgroundImageUrl: string }>`
  align-items: center;
  justify-content: center;
  background: linear-gradient(rgba(40, 50, 90, 0.8), rgba(40, 50, 90, 0.8)),
    url(${({ backgroundImageUrl }) => backgroundImageUrl});
  background-size: cover;
  display: flex;
  flex-direction: column;
  min-height: 340px;
  width: 100%;
`

export const HeroTitle = styled.h1`
  color: ${palette.white};
  font-family: ${typography.fontFamily.ui};
  font-size: ${typography.fontSize.title.large};
  text-align: center;

  @media (min-width: ${breakpoints.lg}px) {
    font-size: 48px;
  }
`

export const RequestInfoContainer = styled.div`
  width: 200px;
  margin-top: ${spacing.majorScale(2)}px;

  @media (min-width: ${breakpoints.lg}px) {
    margin-top: ${spacing.majorScale(6)}px;
  }
`
